import { Box, Grid, Typography } from '@mui/material';
import React, { ChangeEvent } from 'react';
import AppPreview from './AppPreview';
import './AppTour.css'
import LaunchButton from './LaunchButton';
import SellinaAppImage from './SellinaApp.png';
import ChannelkartAppImage from './ChannelKartApp.png';
import eB2BIcon from './eB2BIcon.png';
import AiExpertIcon from './AiExpertIcon.png';

function AppTour() {

    const [open, setOpen] = React.useState<boolean>(false);
    const handleClose = () => {
        setOpen(false);
        setButtonState({...buttonState, checkedA1: false, checkedA2: false})
    };
    const handleToggle = () => {
        setOpen(!open);
    };
    const [buttonState, setButtonState] = React.useState({
        checkedA1: false,
        checkedA2: false
      });
    
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setButtonState({ ...buttonState, [event.target.name]: event.target.checked });
    };
    return (
        <Grid container className="appTourGridContainer" spacing={2}>
            <Grid sm={12} md={6} item>
                <Box className="appTourBoxContainer appTourBox1Color">
                    <div className='imgTagline1'><img src={AiExpertIcon} height="auto" width="100%" alt='App Title' /></div>
                    <div className='imgApp'><img src={SellinaAppImage} height="auto" width="100%" alt='App Preview'/></div>
                    <div className='toggleSwitch'>
                        <LaunchButton name="checkedA1" handleChange={handleChange} checkedA={buttonState.checkedA1} handleToggle={handleToggle}/>
                        <Typography variant='subtitle2' className="appTourLaunchButtonSubtitle" >Take product tour</Typography>
                    </div>
                </Box>
            </Grid>
            <Grid sm={12} md={6} item>
            <Box className="appTourBoxContainer appTourBox2Color">
                    <div className='imgTagline2'><img src={eB2BIcon} height="auto" width="100%" alt='App Title' /></div>
                    <div className='imgApp'><img src={ChannelkartAppImage} height="auto" width="100%" alt='App Preview'/></div>
                    <div className='toggleSwitch'>
                        <LaunchButton name="checkedA2" handleChange={handleChange} checkedA={buttonState.checkedA2} handleToggle={handleToggle}/>
                        <Typography variant='subtitle2' className="appTourLaunchButtonSubtitle" >Take product tour</Typography>
                    </div>
                </Box>
            </Grid>
            <AppPreview open={open} handleClose={handleClose} />
        </Grid>
    )
}

export default AppTour;